export { ZoomProvider } from './ZoomProvider';
export { MagnifyingGlass } from './MagnifyingGlass';
export { useZoomControls } from './ZoomContext';
